<template>
  <Preloader v-if="showPreloader" class="preloader"></Preloader>
  <router-view />
</template>

<script>
import Preloader from './containers/Preloader/Preloader.vue';
import { mapState } from 'vuex';

export default {
  components: {
    Preloader
  },
  computed: mapState({ showPreloader: (state) => state.showPreloader })
};
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Play:wght@400;700&display=swap');

* {
  margin: 0px;
  padding: 0px;
}

h1,
h2,
h3,
h4 {
  font-size: 100%;
  font-weight: normal;
}

.hiddenOverflow {
  overflow: hidden;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.fadeIn-enter-active,
.fadeIn-leave-active {
  transition: opacity 1.3s ease-in-out;
}

.fadeIn-enter-from,
.fadeIn-leave-to {
  opacity: 0;
}

.fadeIn1-enter-active,
.fadeIn1-leave-active {
  transition: opacity 3s ease;
}

.fadeIn1-enter-from,
.fadeIn1-leave-to {
  opacity: 0;
}

.preloader {
  position: absolute;
}

#nav {
  padding: 30px;
  z-index: 1100;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

$color: #4f388d;
$lol: black;

* {
  box-sizing: border-box;
}

html {
  font-size: 1vw;
  font-weight: 400;
  color: $color;

  p,
  span,
  h1,
  h2,
  h3,
  h4,
  button,
  div,
  a {
    font-family: 'Montserrat', sans-serif;
  }
}

@media screen and (min-width: 1440px) {
  html {
    font-size: 14.4px;
  }
}

.sectionTitle {
  font-size: 4.5rem;
  font-weight: 900;
  line-height: 5.5rem;
}

.text18 {
  font-size: 1.25rem;
  line-height: 1.525rem;
  font-weight: 400;
}

.text13 {
  font-size: 0.903rem;
  line-height: 1rem;
  letter-spacing: 0.1rem;
}

.text40 {
  font-size: 2.775rem;
  line-height: 3.4rem;
  font-weight: 700;
}

.text64 {
  font-size: 4.414rem;
  line-height: 5.381rem;
  font-weight: 900;
}

.text26 {
  font-size: 1.8rem;
  line-height: 2.195rem;
  font-weight: 400;
}

.text24 {
  font-size: 1.665rem;
  line-height: 2rem;
  font-weight: 500;
}

.contentWrapperPadding {
  padding: 0 2.778rem;
}

.textSpacing5 {
  letter-spacing: 0.05rem;
}

@media screen and (max-width: 768px) {
  .sectionTitle {
    font-size: 6.25rem;
    line-height: 7.6rem;
    text-align: center;
  }

  .text18 {
    font-size: 4.06rem;
    line-height: 4.95rem;
  }

  .text13 {
    font-size: 4.06rem;
    line-height: 4.95rem;
  }

  .text40 {
    font-size: 4.06rem;
    line-height: 4.95rem;
  }

  .text26 {
    font-size: 4.06rem;
    line-height: 4.95rem;
  }

  .text24 {
    font-size: 5.625rem;
    line-height: 9.14rem;
  }

  .text64 {
    font-size: 15rem;
    line-height: 18.4375rem;
    font-weight: 900;
  }

  .contentWrapperPadding {
    padding: 0;
  }
}

@media screen and (max-width: 900px) {
  .fadeIn-enter-active,
  .fadeIn-leave-active {
    transition: opacity 0.5s ease;
  }

  .fadeIn-enter-from,
  .fadeIn-leave-to {
    opacity: 0;
  }
  .fadeIn1-enter-active,
  .fadeIn1-leave-active {
    transition: opacity 3s ease;
  }

  .fadeIn1-enter-from,
  .fadeIn1-leave-to {
    opacity: 0;
  }
}
</style>
